import { ArrowRight } from 'lucide-react';
import { Base } from '@gandi/ui';
import { InteractiveBlock } from '../../../InteractiveBlock';
import ProductIcon from '../../../ProductIcon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "arrowContainer": "Step-arrowContainer_J0qXW",
  "container": "Step-container_wHcim",
  "svgToRight": "Step-svgToRight_2S5sD",
  "svgFromLeft": "Step-svgFromLeft_1OrUm",
  "body": "Step-body_3P8If",
  "icon": "Step-icon_2gwO0"
};
export function Step({
  iconName,
  title,
  content,
  url
}) {
  return /*#__PURE__*/_jsxs(InteractiveBlock, {
    flex: true,
    to: url,
    "aria-label": title,
    className: styles.container,
    children: [/*#__PURE__*/_jsx(ProductIcon, {
      type: iconName,
      className: styles.icon
    }), /*#__PURE__*/_jsxs(Base, {
      flex: true,
      flexGrow1: true,
      flexJustifyBetween: true,
      color: "base",
      className: styles.body,
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Base, {
          weight: "semibold",
          children: title
        }), /*#__PURE__*/_jsx(Base, {
          children: content
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.arrowContainer,
        children: [/*#__PURE__*/_jsx("span", {
          className: styles.svgFromLeft,
          children: /*#__PURE__*/_jsx(ArrowRight, {})
        }), /*#__PURE__*/_jsx("span", {
          className: styles.svgToRight,
          children: /*#__PURE__*/_jsx(ArrowRight, {})
        })]
      })]
    })]
  });
}